import Experience from "./Experience";
import Lenis from "lenis";

export default class Scroll {
	constructor() {
		this.experience = new Experience();
		this.sizes = this.experience.sizes;

		this.lenis = new Lenis({ autoRaf: false });
		this.velocity = 0;
		this.smoothedVelocity = 0;

		const scrollPercentage = document.querySelector(".scrollPercentage-scroll");
		const scrollDown = document.querySelector(".scrollPercentage-scrollDown");

		this.lenis.on("scroll", (e) => {
			this.velocity = e.velocity * 0.05;

			const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
			const percent = Math.round((e.animatedScroll / maxScroll) * 100);
			scrollPercentage.textContent = `${Math.min(percent, 100)}%`;

			if (percent > 1) {
				scrollDown.style.display = "none";
			}
		});

		this.scrollY = 0;
		window.addEventListener("scroll", () => {
			this.scrollY = (window.scrollY / this.sizes.height) * 5;
		});
	}

	update(time) {
		this.lenis.raf(time);
		this.smoothedVelocity = lerp(this.smoothedVelocity, this.velocity, 0.1);
	}
}

function lerp(a, b, t) {
	return a * (1 - t) + b * t;
}
